import { render, staticRenderFns } from "./HomeBotoxListComponent.vue?vue&type=template&id=7f3d7666"
import script from "./HomeBotoxListComponent.vue?vue&type=script&lang=js"
export * from "./HomeBotoxListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports